import {useQuery, useQueryClient} from '@tanstack/react-query';
import {fetchRecords} from '../services/ReportRunsService';
import {useState, useEffect} from 'react';
import {ReportRun} from '../types';
import {usePagination} from '../../../hooks/usePagination';

export const useReportRuns = () => {
    const queryClient = useQueryClient();
    const [keyword, setKeyword] = useState('');
    const pagination = usePagination();

    const reportRunsQuery = useQuery({
        queryKey: ['reportRuns', pagination.currentToken],
        queryFn: () => fetchRecords({}, pagination.pageSize, pagination.currentToken),
    });

    useEffect(() => {
        if (reportRunsQuery.data) pagination.setNextToken(reportRunsQuery.data.nextToken);
    }, [reportRunsQuery.data]);

    const fetchRecordsAction = () => {
        queryClient.invalidateQueries({queryKey: ['reportRuns']});
    };

    const handleFilterByKeyword = (newKeyword: string) => {
        setKeyword(newKeyword);
    };

    const allItems: ReportRun[] = reportRunsQuery.data?.items || [];

    const visibleItems = keyword
        ? allItems.filter(item => {
            const search = keyword.toLowerCase();
            return (
                item.id?.toLowerCase().includes(search) ||
                item.reportType?.toLowerCase().includes(search) ||
                item.status?.toLowerCase().includes(search)
            );
        })
        : allItems;

    return {
        items: allItems,
        visibleItems,
        loading: reportRunsQuery.isLoading,
        keyword,
        visibleCount: visibleItems.length,
        totalCount: allItems.length,
        fetchRecords: fetchRecordsAction,
        handleFilterByKeyword,
        currentPage: pagination.currentPage,
        hasNext: pagination.hasNext,
        hasPrevious: pagination.hasPrevious,
        goToNextPage: pagination.goToNextPage,
        goToPreviousPage: pagination.goToPreviousPage,
    };
};
